import { render, staticRenderFns } from "./workflow-arrow.vue?vue&type=template&id=c5367320&functional=true"
import script from "./workflow-arrow.vue?vue&type=script&lang=js"
export * from "./workflow-arrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports